import React, { useState, useEffect } from "react"
import Menu from "../menu/menu"
import styled from "styled-components"
import "./stat.css"
// import ReactTable from "react-table"
// import "react-table/react-table.css"
import { PieChart, Pie, Sector, Cell, Treemap } from "recharts"
import { constants } from "os"
import useWindowWidth from '../UI/windowEffects'

// [ { TeamId: 1, TeamName: "Ichiban", MemberCount: 22 }, {} ]
const COLORS = ["#f9ca24", "#f0932b", "#eb4d4b", "#6ab04c", "#c7ecee", "#686de0","#be2edd"]

const MemberStatWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 auto;
  height: 100%;
`

const Header = styled.div`
  background: #800;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  /* max-width: 80%; */
  /* align-self: center; */
  /* justify-content: center; */
`

const StyledPieChart = styled(PieChart)`
  align-self: center;
`

const StyledTreemap = styled(Treemap)`
  align-self: center;
`

const MemberStat = styled.div`
  padding: 10px;

  .memberStat-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 10px;
  }

  .memberStat-item.total {
    font-weight: bold;
    color: #b52;
    background: rgba(0, 0, 0, 0.1);
    padding: 3px;
  }
`

const CustomizedContent = props => {
  const {
    root,
    depth,
    x,
    y,
    width,
    height,
    index,
    payload,
    colors,
    rank,
    name,
    color,
    value
  } = props

  // console.log("props=",props);

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{
          fill: depth == 1 ? color : null,
          stroke: "#aaa",
          strokeWidth: 1,
          strokeOpacity: 1
        }}
      />
      {depth === 1 ? (
        <text
          x={x + width / 2}
          y={y + height / 2 + 7}
          textAnchor="middle"
          fill="#fff"
          fontSize={12}
          strokeWidth={1}
          style={{ fontWeight: "normal" }}
        >
          {name}
        </text>
      ) : null}
      {depth === 1 ? (
        <text
          x={x + width / 2}
          y={y + height / 2 + 26}
          textAnchor="middle"
          fill="#fff"
          fontSize={16}
          strokeWidth={1}
          style={{ fontWeight: "normal" }}
        >
          {value}
        </text>
      ) : null}
    </g>
  )
}

/***********************************************
 *
 * STAT COMPONENT
 *
 ***********************************************/
const Stat = props => {
  const [status, setStatus] = useState([])
  const [rankStatus, setRankStatus] = useState([])
  const [dataloaded, setDataloaded] = useState(false)
  const [COLORS, setCOLORS] = useState( ["#f9ca24", "#f0932b", "#eb4d4b", "#6ab04c", "#c7ecee", "#686de0","#be2edd"])


  const windowWidth = useWindowWidth()

  // get total active


  useEffect(() => {
    // Check if members data has been loaded if not then load members data.
    if (props.firebaseReady && !props.membersLoaded) {
      props.loadMembers()
    }

    console.log("data in da house: ", props)
    getMemberStat()
    getRankStat()
  }, [props.firebaseReady, props.membersLoaded])

  const getMemberStat = () => {
    const newStatus = props.members.reduce((all, m) => {
      let newAll = [...all]
      let teamStatExist = false

      const foundTeamStat = newAll.map(a => {
        if (a.TeamId == m.TeamId) {
          // found
          a.MemberCount++
          teamStatExist = true
        }

        return a
      })

      if (!teamStatExist && m.TeamId != 99) {
        newAll.push({
          TeamId: m.TeamId,
          TeamName: m.TeamName,
          MemberCount: 1
        })
      }

      return newAll
    }, [])

    setStatus(newStatus)
  }

  const getTotalActive = () => {
    return props.members.reduce((acc, m) => {
      if (m.TeamId == 0 || m.TeamId == 1 || m.TeamId == 2 || m.TeamId == 3) {
        acc++
      }

      return acc
    }, 0)
  }

  // count number of different levels
  const getRankStat = () => {
    const uniqueDimensions = props.ranks.reduce((all, r) => {
      const exist =
        r.level && r.level.LevelTitle ? all.find(x => x.name == r.level.LevelTitle) : null

      // exceptions
      if (r.level && r.level.LevelGroup != "JDK") {
        return all
      }

      if (r.level && r.level.LevelTitle) {
        if (!exist) {
          // set color
          let color = "#777"
          if (r.level.LevelTitle.toUpperCase().indexOf("DAN") > -1) {
            color = "#000"
          }
          if (
            r.level.LevelTitle.toUpperCase().indexOf("3") > -1 ||
            r.level.LevelTitle.toUpperCase().indexOf("2") > -1 ||
            r.level.LevelTitle.toUpperCase().indexOf("1") > -1
          ) {
            color = "#630"
          }
          if (
            r.level.LevelTitle.toUpperCase().indexOf("5") > -1 ||
            r.level.LevelTitle.toUpperCase().indexOf("4") > -1
          ) {
            color = "#026"
          }
          if (
            r.level.LevelTitle.toUpperCase().indexOf("6") > -1 ||
            r.level.LevelTitle.toUpperCase().indexOf("7") > -1
          ) {
            color = "#060"
          }
          if (
            r.level.LevelTitle.toUpperCase().indexOf("8") > -1 ||
            r.level.LevelTitle.toUpperCase().indexOf("9") > -1
          ) {
            color = "#a80"
          }

          all.push({ name: r.level.LevelTitle, value: 1, color })
        } else {
          exist.value++ // exist is a referene to all array.  (this is a Ninja move!)
          all = [...all]
        }
      }

      return all
    }, [])

    console.log("uniqueDimensions:", uniqueDimensions)

    setRankStatus(uniqueDimensions)
  }

  const memberStat = status.map(stat => {
    return (
      <div className="memberStat-item">
        <div>
          {stat.TeamName} ({stat.TeamId})
        </div>
        <div>{stat.MemberCount}</div>
      </div>
    )
  })

  const totalActive = (
    <div className="memberStat-item total">
      <div>Aktive ialt (ekskl. nye)</div>
      <div>{getTotalActive()}</div>
    </div>
  )

  const columns = [
    {
      Header: "Hold",
      accessor: "TeamName",
      minWidth: 180
    }
    // {
    //   Header: "ID",
    //   accessor: "TeamId",
    //   width: 90
    // },
    // {
    //   Header: "Medlems ID",
    //   accessor: "ID"
    // }
  ]

  const drawPieChart = (
    <StyledPieChart width={240} height={240}>
      <Pie
        data={status}
        cx={120}
        cy={120}
        labelLine={false}
        // label={}
        nameKey="TeamName"
        dataKey="MemberCount"
        innerRadius={40}
        outerRadius={110}
        // fill="#8884d8"
      >
        {status.map((entry, index) => {
          return <Cell fill={COLORS[index % COLORS.length]} />
        })}
      </Pie>
    </StyledPieChart>
  )

  const drawTreeMap = props.membersLoaded ? (
    <StyledTreemap
      width={windowWidth}
      height={700}
      data={rankStatus}
      nameKey="name"
      dataKey="value"
      stroke="#fff"
      // fill="#8884d8"
      content={<CustomizedContent colors={COLORS} />}
    />
  ) : null

  return (
    <MemberStatWrap>
      {/* <Menu color="black" currentlyLoggedInUser={props.currentlyLoggedInUser} /> */}
      <Menu color="white" currentlyLoggedInUser={props.currentlyLoggedInUser} />
      <Header>Statistikker</Header>
      <Content id="content">
        {drawPieChart}
        <MemberStat id="memberstat">
          {memberStat}
          {totalActive}
        </MemberStat>
      </Content>
    </MemberStatWrap>
  )
}

export default Stat
